import React from "react";
import popOverImage from "../../../images/new-images/popover-image.png";
import "./popover-inner-content.css";

const Renderpopoverinnercontent = (props) => {
  return (
    <div className="popover-content-wrapper">
      <h1>{props.assessmentheading}</h1>
      <img src={popOverImage} className="pop-over-image" />
      <div dangerouslySetInnerHTML={{ __html: props.assesmentdescription }} />
      <button onClick={props.handleClosePopOver}>Got It</button>
    </div>
  );
};
export default Renderpopoverinnercontent;



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-assessments/popover-inner-content.jsx